import { LinkedAccountReauthRequiredReason } from 'types/LinkedAccount';

const CALENDAR_ACCESS_DENIED_MARKERS = [
	'notacalendaruser',
	'calendar_access_denied',
	'the user must be signed up for google calendar',
	'calendar access denied',
];

type ApiErrorData = {
	message?: unknown;
	code?: unknown;
	error?: unknown;
};

type ApiErrorShape = {
	message?: unknown;
	response?: {
		data?: ApiErrorData;
	};
};

const toNormalizedString = (value: unknown): string => (typeof value === 'string' ? value.toLowerCase() : '');

const extractBusinessErrorParts = (error: unknown): string[] => {
	const typedError = error as ApiErrorShape;
	const responseData = typedError?.response?.data;

	return [
		toNormalizedString(responseData?.code),
		toNormalizedString(responseData?.error),
		toNormalizedString(responseData?.message),
		toNormalizedString(typedError?.message),
	].filter((part) => part.length > 0);
};

export const isCalendarAccessDeniedBusinessError = (error: unknown): boolean => {
	const errorParts = extractBusinessErrorParts(error);

	return errorParts.some((part) => CALENDAR_ACCESS_DENIED_MARKERS.some((marker) => part.includes(marker)));
};

export const getLinkedAccountReauthMessageKey = (reason?: LinkedAccountReauthRequiredReason | null): string => {
	switch (reason) {
		case LinkedAccountReauthRequiredReason.TOKEN_EXPIRED:
			return 'linkedAccount.myAccount.reauthRequiredReason.tokenExpired';
		case LinkedAccountReauthRequiredReason.CALENDAR_ACCESS_DENIED:
			return 'linkedAccount.myAccount.reauthRequiredReason.calendarAccessDenied';
		default:
			return 'linkedAccount.myAccount.reauthRequiredReason.fallback';
	}
};
